import { ShieldAlert, MonitorX, FileX, Smartphone } from 'lucide-react'

// Shown before every identity verification session so the candidate clearly sees
// that only an original, physical document is accepted (mirrors the wording on the
// WelcomeAndStatusSelection screen and the generated consent PDF).
const PhysicalDocumentNotice = () => {
    return (
        <div className="rounded-2xl border border-amber-300 bg-amber-50 p-5 sm:p-6 space-y-5">
            <div className="flex items-start gap-3">
                <div className="w-11 h-11 shrink-0 rounded-full bg-amber-100 border border-amber-300 flex items-center justify-center">
                    <ShieldAlert className="w-6 h-6 text-amber-600" />
                </div>
                <div>
                    <h3 className="text-base font-bold text-amber-800">
                        Before you start: PHYSICAL DOCUMENTS ONLY
                    </h3>
                    <p className="text-sm text-amber-900 mt-0.5">
                        Please have your <strong>ORIGINAL, PHYSICAL DOCUMENT</strong> in your hand.
                        Anything else is automatically rejected by our security AI.
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <div className="relative rounded-xl bg-white border border-amber-200 p-4 flex flex-col items-center text-center gap-2">
                    <span className="absolute top-2 right-2 flex items-center justify-center w-5 h-5 rounded-full bg-red-500 text-white text-xs font-bold leading-none">✕</span>
                    <MonitorX className="w-9 h-9 text-red-500" />
                    <p className="text-sm font-semibold text-gray-800">No screen photos</p>
                    <p className="text-xs text-gray-500">
                        Photos taken off a computer, laptop, phone, or tablet screen are rejected.
                    </p>
                </div>

                <div className="relative rounded-xl bg-white border border-amber-200 p-4 flex flex-col items-center text-center gap-2">
                    <span className="absolute top-2 right-2 flex items-center justify-center w-5 h-5 rounded-full bg-red-500 text-white text-xs font-bold leading-none">✕</span>
                    <FileX className="w-9 h-9 text-red-500" />
                    <p className="text-sm font-semibold text-gray-800">No photocopies or scans</p>
                    <p className="text-xs text-gray-500">
                        Printed copies or digital PDFs of IDs/cards are not permitted.
                    </p>
                </div>

                <div className="rounded-xl bg-white border border-amber-200 p-4 flex flex-col items-center text-center gap-2">
                    <Smartphone className="w-9 h-9 text-blue-600" />
                    <p className="text-sm font-semibold text-gray-800">Use your phone</p>
                    <p className="text-xs text-gray-500">
                        On a desktop you'll switch to your smartphone camera to capture the document live.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default PhysicalDocumentNotice
